import { TextBody, TextTitle } from '@pypestream/design-system';
import { FC } from 'react';

import type { WorkflowStage } from '../stores/utils/workflow-stage';

import './stage-placeholder.scss';

const STAGE_LABEL: Record<Exclude<WorkflowStage, 'build'>, string> = {
  design: 'Design',
  validate: 'Validate',
  deploy: 'Deploy',
  observe: 'Observe',
};

/**
 * Project Bobcat, 5-stage nav Phase 1 — an honest stand-in for the four
 * stages that don't have real content yet. Each gets its own dedicated,
 * separately-phased, separately-flagged build (see "PR Spec: 5-Stage Nav"):
 * Design's Solution Overview, Deploy's relocated Versions/publish flow,
 * Validate's new Engagement-API chat harness, Observe's link-out to the real
 * Observer tooling. This exists only so the new nav is fully clickable end
 * to end in the meantime, not to simulate any of that content.
 */
export const StagePlaceholder: FC<{
  stage: Exclude<WorkflowStage, 'build'>;
}> = ({ stage }) => (
  <div className="c-stage-placeholder" data-testid="bobcat-stage-placeholder">
    <TextTitle size="small">{STAGE_LABEL[stage]}</TextTitle>
    <TextBody variant="secondary">
      This stage is being built — check back soon.
    </TextBody>
  </div>
);
